// Password validation utility
export const validatePassword = (password) => {
  const errors = [];
  
  // Minimum 15 characters
  if (password.length < 15) {
    errors.push('Password must be at least 15 characters long');
  }
  
  // At least 1 capital letter
  if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least 1 capital letter');
  }
  
  // At least 1 special character
  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
    errors.push('Password must contain at least 1 special character');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

export const getPasswordPolicyText = () => {
  return 'Password Policy: Minimum 15 characters, including at least 1 capital letter and 1 special character.';
};

export const getPasswordStrength = (password) => {
  let strength = 0;
  let feedback = [];
  
  // Length check
  if (password.length >= 15) {
    strength += 1;
  } else {
    feedback.push('At least 15 characters');
  }
  
  // Capital letter check
  if (/[A-Z]/.test(password)) {
    strength += 1;
  } else {
    feedback.push('At least 1 capital letter');
  }
  
  // Special character check
  if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
    strength += 1;
  } else {
    feedback.push('At least 1 special character');
  }
  
  // Additional strength checks
  if (/[a-z]/.test(password)) {
    strength += 0.5;
  }
  
  if (/[0-9]/.test(password)) {
    strength += 0.5;
  }
  
  return {
    strength: Math.min(strength / 3, 1), // Normalize to 0-1
    feedback: feedback.length > 0 ? feedback : ['Strong password!']
  };
};
